<div class="search-form" [class.collapsed]="collapsed">
  <!-- Anna's Archive Domain Health Status -->
  <div class="health-status-row">
    <div class="health-item"
         *ngFor="let domain of annaDomains"
         [ngClass]="getHealthColorClass(domain.health)">
      <div class="health-domain">.{{ domain.extension }}</div>
      <div class="health-percent">{{ domain.health !== null ? (domain.health + '%') : '...' }}</div>
    </div>
  </div>

  <form (ngSubmit)="onSubmit()">
    <!-- Book name -->
    <mat-form-field
      appearance="outline"
      class="w-100 ai-search-field"
      [floatLabel]="aiSearchExpanded ? 'always' : 'auto'"
    >
      <mat-label>Book name</mat-label>
      <ng-container *ngIf="!aiSearchExpanded; else aiSearchInput">
        <input
          matInput
          [(ngModel)]="searchTerm"
          (ngModelChange)="onSearchTermChange($event)"
          name="searchTerm"
          required
        />
      </ng-container>
      <ng-template #aiSearchInput>
        <textarea
          matInput
          [(ngModel)]="aiSearchQuery"
          name="aiSearchQuery"
          rows="4"
          placeholder="Ask for books, e.g., top-rated Hugo winners from the 1980s"
        ></textarea>
      </ng-template>
      <button
        mat-icon-button
        matSuffix
        type="button"
        class="ai-toggle"
        (click)="toggleAiSearch()"
        [attr.aria-label]="aiSearchExpanded ? 'Close AI search' : 'Open AI search'"
      >
        <mat-icon>{{ aiSearchExpanded ? 'close' : 'smart_toy' }}</mat-icon>
      </button>
    </mat-form-field>

    <!-- Author suggestions -->
    <mat-form-field appearance="outline" class="w-100 author-dropdown">
      <mat-label>Author</mat-label>
      <mat-select
        [(ngModel)]="selectedAuthor"
        name="selectedAuthor"
        [disabled]="aiSearchExpanded || loadingAuthors || authorSuggestions.length === 0"
        panelClass="author-select-panel"
      >
        <mat-option value="">All Authors</mat-option>
        <mat-option *ngFor="let suggestion of authorSuggestions" [value]="suggestion.author">
          {{ suggestion.author }} ({{ suggestion.confidence }})
        </mat-option>
      </mat-select>
      <mat-spinner
        *ngIf="loadingAuthors"
        matSuffix
        diameter="20"
        style="margin-right: 8px;"
      ></mat-spinner>
    </mat-form-field>

    <!-- Filters row -->
    <app-search-filters
      [selectedFormat]="selectedFormat"
      [availableFormats]="availableFormats"
      [downloadsLeft]="downloadsLeft"
      [downloadsPerDay]="downloadsPerDay"
      [disabled]="relatedBooksModalOpen"
      (formatChange)="onFormatChange($event)"
    ></app-search-filters>

    <!-- Search button -->
    <button
      mat-raised-button
      color="primary"
      type="submit"
      [disabled]="loading"
    >
      {{ aiSearchExpanded ? 'Ask AI' : 'Search' }}
    </button>

    <!-- Find Related Books button -->
    <button
      mat-raised-button
      color="accent"
      type="button"
      (click)="onOpenRelatedBooks()"
      [disabled]="!selectedAuthor"
      [class.halftone]="!selectedAuthor"
    >
      Find Related Books
    </button>

    <!-- Source toggle -->
    <div class="source-toggle-row">
      <mat-slide-toggle
        [(ngModel)]="useLibGen"
        name="useLibGen"
        color="primary">
        {{ useLibGen ? 'Using LibGen' : 'Using Anna\'s Archive' }}
      </mat-slide-toggle>
    </div>

    <!-- Feedback -->
    <div *ngIf="error" class="error">{{ error }}</div>
    <div *ngIf="loading" class="loading">Loading…</div>
  </form>
</div>
